import styled from 'styled-components';

export const MapStyles = styled.div`
  position: relative;
  width: 100%;
  background: transparent;

  svg {
    display: block;
    width: 100%;
    height: auto;
  }

  .zone-path {
    stroke: #ffffff66;
    stroke-width: 0.8;
    fill-opacity: 0.55;
    transition:
      stroke-width 120ms ease,
      stroke 120ms ease,
      fill-opacity 120ms ease;
  }

  .zone-path.is-active {
    stroke: #fff;
    stroke-width: 1.8;
    fill-opacity: 0.85;
  }

  .legend-title {
    font-family: 'SBS Sans', sans-serif;
    font-size: 11px;
    fill: #cccccc;
    font-weight: bold;
  }

  .legend-label {
    font-family: 'SBS Sans', sans-serif;
    font-size: 10px;
    fill: #aaaaaa;
  }

  .zone-label {
    font-family: 'SBS Sans', sans-serif;
    font-size: 7px;
    fill: #ffffffcc;
    pointer-events: none;
    text-anchor: middle;
  }

  .map-tooltip {
    position: absolute;
    min-width: 220px;
    max-width: 300px;
    background: rgba(10, 25, 41, 0.75);
    border: 1px solid #ffffff44;
    border-radius: 8px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
    color: #f2f5f7;
    font-family: 'SBS Sans', sans-serif;
    font-size: 12px;
    line-height: 1.3;
    padding: 10px;
    pointer-events: none;
    z-index: 5;
  }

  .map-tooltip-title {
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .map-tooltip-bar-wrap {
    display: flex;
    width: 100%;
    height: 14px;
    border-radius: 999px;
    overflow: hidden;
    margin-bottom: 8px;
    background: #213244;
  }

  .map-tooltip-bar {
    height: 100%;
  }

  .map-tooltip-bar-unsustainable {
    background: #d97706;
  }

  .map-tooltip-bar-sustainable {
    background: #2f6bff;
  }

  .map-tooltip-row {
    display: grid;
    grid-template-columns: 10px 1fr auto;
    align-items: center;
    gap: 8px;
    margin: 3px 0;
  }

  .map-tooltip-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
  }

  .map-tooltip-dot-unsustainable {
    background: #d97706;
  }

  .map-tooltip-dot-sustainable {
    background: #2f6bff;
  }
`;
